module.exports = __webpack_public_path__ + "error404.png";